import React, { useEffect, useState } from 'react'
import CoursesList from './CoursesList'
import SetPage from '../../data/SetPage'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ModalStyle from '../../data/ModalStyle'
import Close from '@mui/icons-material/Close'
import { PlayCircle } from '@mui/icons-material'
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import "../../assets/css/banner.css"; import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import img from "../../assets/images/connection/avatar10.jpg"
import img2 from "../../assets/images/course/course2.png"


const OnlineCourses = () => {

  useEffect(() => {
    SetPage("Live Courses")
    window.scrollTo(0, 0)
  }, [])
  const [demo, setdemo] = useState(false)
  return (
    <div className="pb-5 mb-5">
      <Helmet>‍
        <title>Online Courses | Online Training Programs - SiliconMinds</title>‍
        <meta name="description" content="Join Our Live Online Courses: Learn from Anywhere, Anytime with our interactive online courses. Enhance Your Skills with SiliconMinds Today!" />
        <meta name="twitter:card" content="" />
        <meta name="twitter:site" content="@skillsuprise" />
        <meta name="twitter:creator" content="@skillsuprise" />
        <meta name="twitter:title" content="" />
        <meta name="twitter:description" content="" />
        <meta name="twitter:image" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>

      <Modal
        open={demo}
        onClose={() => setdemo(false)}

      >
        <Box sx={ModalStyle} className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2">
          <div className="d-flex justify-content-between">
            <h4>Introduction</h4>
            <Close className="text-danger" type="button" onClick={() => setdemo(false)} />
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <video poster="https://skillsuprise.com/data/images/online-course-poster.png" className="w-100" autoPlay src="https://skillsuprise.com/data/videos/online-demo.mp4"></video>
          </Typography>
        </Box>
      </Modal>

      <section className="banner-section online-crumb">

        {/* Background Shapes */}
        <img
          className="img-fluid d-none d-lg-flex banner-bg1"
          src="/assets/img/bg/bg-15.png"
          alt=""
        />
        <img
          className="img-fluid d-none d-lg-flex banner-bg2"
          src="/assets/img/bg/bg-16.png"
          alt=""
        />
        <img
          className="img-fluid d-none d-lg-flex banner-bg3"
          src="/assets/img/bg/bg-17.png"
          alt=""
        />
        <img
          className="img-fluid d-none d-lg-flex banner-bg4"
          src="/assets/img/bg/bg-18.png"
          alt=""
        />

        <div className="container">
          <div className="row align-items-center justify-content-between">

            {/* LEFT CONTENT */}
            <div className="col-xl-7 col-lg-7 text-white">
              <div className="banner-content pe-lg-5">
                <span className="hero-title">
                  Live Interactive Programs
                </span>

                <h1 className="mb-4">
                  Online <span>Training</span> Programs by Industry{" "}
                  <span>Experts</span>
                </h1>

                <p className="fs-lg mb-4 text-light">
                  Experience online trainings like never before with interactive,
                  daily live sessions designed to upgrade your skills from anywhere.
                </p>

                <button
                  onClick={() => setdemo(true)}
                  className="btn btn-orng rounded-pill px-4 py-2"
                >
                  <PlayCircle className="me-2" />
                  Watch Demo
                </button>

                {/* COUNTERS */}
                <div className="d-flex gap-4 flex-wrap mt-4 mb-2">
                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-warning mb-0">10K+</h5>
                      <p className="mb-0 text-light">Learners</p>
                    </div>
                  </div>

                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-info mb-0">150+</h5>
                      <p className="mb-0 text-light">Live Courses</p>
                    </div>
                  </div>

                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-success mb-0">50+</h5>
                      <p className="mb-0 text-light">Expert Trainers</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-5 d-none d-lg-block">
              <div className="banner-course-card">
                <div className="hero-course-card mb-5">
                  <div className="hero-course-image">
                    <img src={img2} alt="Course" />

                    <div className="hero-heart">❤</div>
                    <div className="hero-brand">N</div>
                  </div>

                  <div className="hero-course-body">
                    <div className="hero-author">
                      <img src={img} alt="Instructor" />
                      <span>David Benitz</span>
                      <span className="hero-category">Productivity</span>
                    </div>

                    <h5>Design for Testability</h5>

                    <div className="hero-rating d-flex">
                      <div>⭐ 5.0 <span>(210 Reviews)</span></div>
                      {/* <button
                        onClick={() => setdemo(true)}
                        className="btn btn-orng rounded-pill  px-2 py-1 ms-auto"
                      >
                        <PlayCircle className="me-2" />
                        Watch Demo
                      </button> */}
                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
        </div>
      </section>

      <div className="container sm-p-0 pb-5">
        <CoursesList mode={"live"} />
      </div>
    </div>
  )
}

export default OnlineCourses